export default "__VITE_ASSET__52977ac3__"